import React from 'react';
import Trans from '@lib/components/Trans/Trans';
import { MonitoringEntity } from '../enums';

const getPageTabs = () => [
  {
    label: <Trans i18nKey="sites" />,
    value: MonitoringEntity.Site,
  },
  {
    label: <Trans i18nKey="sectors" />,
    value: MonitoringEntity.Sector,
  },
];

export default getPageTabs;
